var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "yn_icon",
    "data-name": "YesNo Icon",
    d: "M17.341,4.562,4.562,17.341a1.509,1.509,0,0,0,1.1,1.1L18.446,5.659A1.558,1.558,0,0,0,17.341,4.562ZM11.407,4.5,4.5,11.407v2.2L13.608,4.5Zm-5.351,0A1.56,1.56,0,0,0,4.5,6.056V7.611L7.611,4.5Zm10.889,14A1.567,1.567,0,0,0,18.5,16.944V15.389L15.389,18.5Zm-7.552,0h2.2L18.5,11.593v-2.2Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#8f6aea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYnIcon);
export default __webpack_public_path__ + "static/media/yn_icon.393217c2d6df4ae4eeb913c7654dba6c.svg";
export { ForwardRef as ReactComponent };